import { ScaleBarTextSymbolPanel } from './ScaleBarTextSymbolPanel';
import type { LayoutTextSymbol } from './layoutTypes';

export interface LayoutTextSymbolPanelProps {
  readonly value: LayoutTextSymbol;
  readonly heading: string;
  readonly testId: string;
  readonly onApply: (value: LayoutTextSymbol) => void;
  readonly onBack: () => void;
}

/**
 * Shared layout text-symbol editor. The scale-bar implementation remains the
 * compatibility host while legends and future layout text use this neutral API.
 */
export function LayoutTextSymbolPanel(props: LayoutTextSymbolPanelProps) {
  return <ScaleBarTextSymbolPanel {...props} />;
}
